
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 239 182","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M188.034 69.135s19.093 11.38 26.695-13.137c4.768-15.347-13.228-24.084-16.839-10.451-2.833 10.72 15.243 29.516 29.667 18.734 7.662-5.722 8.42-13.282 8.42-13.282","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M81.136 21.38a65.343 65.343 0 015.347-.228H129.1c33.398 0 60.471 28.03 60.471 62.606v4.545c0 25.798-15.063 47.94-36.59 57.524M71.7 149.091c-22.107-5.205-38.666-22.39-43.834-45.4L3.747 92.289V71.758l24.56-5.308c3.89-17.392 16.2-32.223 32.839-39.824M124.529 150.888H98.533M72.657 142.254l-4.57 32.801L80.179 179l21.508-34.556","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M150.486 140.478l4.968 34.577-12.09 3.945-21.926-35.155M61.545 32.038V3.018c-.499-.476 16.52 8.86 21.308 23.505M95.66 41.89h24.241","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M60.068 64.178c1.873 0 3.391-1.572 3.391-3.512s-1.518-3.511-3.392-3.511c-1.873 0-3.391 1.572-3.391 3.511 0 1.94 1.518 3.512 3.392 3.512z","fill":"#fff","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    